import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "popover popover--icon" }
const _hoisted_2 = {
  key: 0,
  ref: "popover",
  class: "popover__box popover__box--lg"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "info-hand" }, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  ref: "arrow",
  class: "popover__box__arrow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(['popover__toggle', 'popover__toggle--' + _ctx.type, _ctx.buttonClass]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["stop"]))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            id: "popup-close",
            class: "close",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["stop"]))
          }),
          _hoisted_3,
          _createElementVNode("div", { innerHTML: _ctx.innerData }, null, 8, _hoisted_4),
          _renderSlot(_ctx.$slots, "body", { class: "popover" }),
          _createElementVNode("div", _hoisted_5, null, 512)
        ], 512))
      : _createCommentVNode("", true)
  ]))
}